import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../auth/AuthHandler";
import { ReleaseTrackerDataService } from "../../../data/ReleaseTrackerDataService";
import { TopButtons, ProductCard } from "./../../../components/index";
import { checkName } from "../../../helper/checkName";
import { useBreadcrumb } from "../../../hooks/useBreadcrumb";

export default function Peripherals() {
  const authCtx = useContext(AuthContext);
  const [data, setData] = useState(null);

  useBreadcrumb(
    [
      { label: "Home", path: "/" },
      { label: "Firmware", path: "/firmware" },
      { label: "Peripherals" },
    ],
    [], // run once on mount
  );

  useEffect(() => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);
    relTrackerService
      .getFirmwareFamilies("peripherals")
      .then((fetched) => {
        
        const sorted = [...fetched].sort((a, b) =>
          checkName(a.Name || '').localeCompare(checkName(b.Name || ''), undefined, { sensitivity: 'base' })
        );
        
        setData(sorted);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [authCtx]);

  return (
    <div className="peripherals">
      <TopButtons />
      <div className="product-cards-container">
        {data &&
          data.map((value) => (
            <ProductCard
              key={value.Name}
              title={checkName(value.Name)}
              url={{ pathname: "peripherals/" + value.Name, data: value }}
              img={value.Name}
            />
          ))}
      </div>
    </div>
  );
}
